import { Dispatch, createAction, createReducer } from '@reduxjs/toolkit';
import { RootState } from 'ducks';
import { injectReducer } from 'ducks/configureStore';
import ClothHangersSheet from './ClothHangersSheet';
import { Feature, RenderLocation, RendersComponent, ShouldReset } from 'features/Feature';

interface ClothHangersState {
  showClothHangersSheet: boolean;
  dismissed: boolean;
}

const initialState: ClothHangersState = {
  showClothHangersSheet: false,
  dismissed: false
};

type ExtendedRootState = RootState & {
  clothHangers?: ClothHangersState;
};

export const showClothHangersSheet = createAction('clothHangers/showClothHangersSheet');
export const hideClothHangersSheet = createAction('clothHangers/hideClothHangersSheet');
export const setDismissed = createAction<boolean>('clothHangers/setDismissed');
export const resetClothHangersSheet = createAction('clothHangers/resetClothHangersSheet');

export const isModalVisible = (state: ExtendedRootState) =>
  state.clothHangers?.showClothHangersSheet;
export const wasDismissed = (state: ExtendedRootState) => state.clothHangers?.dismissed;

const clothHangersReducer = createReducer(initialState, builder => {
  builder
    .addCase(showClothHangersSheet, state => {
      state.showClothHangersSheet = true;
    })
    .addCase(hideClothHangersSheet, state => {
      state.showClothHangersSheet = false;
    })
    .addCase(setDismissed, (state, action) => {
      state.dismissed = action.payload;
      state.showClothHangersSheet = false;
    })
    .addCase(resetClothHangersSheet, state => {
      state.dismissed = initialState.dismissed;
    });
});

export class ClothHangersFeature extends Feature implements RendersComponent, ShouldReset {
  protected init(): void {
    injectReducer<ClothHangersState>('clothHangers', clothHangersReducer);
  }
  render(location: RenderLocation) {
    if (location !== RenderLocation.Root) return;
    return ClothHangersSheet;
  }
  reset(dispatch: Dispatch) {
    dispatch(resetClothHangersSheet());
  }
}
